<div class="templates-form">
    <h5 *ngIf="!isEditMode">{{ 'aumico_templates_form_create_template' | i18next }}</h5>
    <h5 *ngIf="isEditMode">{{ 'aumico_templates_form_update_template' | i18next }}</h5>
    <br /><br />
    <mat-form-field>
        <mat-label>{{ 'aumico_templates_name' | i18next }}</mat-label>
        <input matInput [(ngModel)]="template.name" [formControl]="templateNameControl" required />
        <mat-error *ngIf="templateNameControl.hasError('required')">
            {{ 'aumico_templates_form_enter_template_name_error' | i18next }}
        </mat-error>
        <mat-error *ngIf="templateNameControl.hasError('templateNameExists')">
            {{ 'aumico_templates_form_template_name_exists_error' | i18next }}
        </mat-error>
    </mat-form-field>
    <br /><br />
    <mat-form-field>
        <mat-label>{{ 'aumico_templates_form_account_basis' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.accountBasis" [formControl]="templateAccountBasisControl" required>
            <mat-option *ngFor="let accountBasis of settings.accountBases" [value]="accountBasis">
                {{ accountBasis }}
            </mat-option>
        </mat-select>

        <mat-error *ngIf="templateAccountBasisControl.hasError('required')">
            {{ 'aumico_templates_form_select_account_basis_error' | i18next }}
        </mat-error>
        <mat-error *ngIf="templateAccountBasisControl.hasError('templateAccountBasisAndLegalFormExists')">
            {{ 'aumico_templates_combination_exist_error' | i18next }}
        </mat-error>
    </mat-form-field>
    <br /><br />
    <mat-form-field>
        <mat-label>{{ 'aumico_templates_form_legal_form' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.legalForm" [formControl]="templateLegalFormControl" required>
            <mat-option *ngFor="let legalForm of settings.legalForms" [value]="legalForm">
                {{ legalForm }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="templateLegalFormControl.hasError('required')">
            {{ 'aumico_templates_form_select_legal_form_error' | i18next }}
        </mat-error>
        <mat-error *ngIf="templateLegalFormControl.hasError('templateAccountBasisAndLegalFormExists')">
            {{ 'aumico_templates_combination_exist_error' | i18next }}
        </mat-error>
    </mat-form-field>
    <br /><br />
    <mat-form-field *ngIf="template.type === TemplateType.BALANCE">
        <mat-label>{{ 'aumico_templates_form_cash_and_cash_equivalents' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.cashAndCash" required>
            <mat-option *ngFor="let option of fliOptions" [value]="option">
                {{ option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br /><br />
    <mat-form-field *ngIf="template.type === TemplateType.BALANCE">
        <mat-label>{{ 'aumico_templates_form_profit_of_the_year' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.profitOfTheYear" required>
            <mat-option *ngFor="let option of fliOptions" [value]="option">
                {{ option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br /><br />
    <mat-form-field *ngIf="template.type === TemplateType.BALANCE">
        <mat-label>{{ 'aumico_templates_form_annual_surplus' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.annualSurplusFliName">
            <mat-option *ngFor="let option of fliOptions" [value]="option">
                {{ option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br /><br />
    <mat-form-field *ngIf="template.type === TemplateType.BALANCE">
        <mat-label>{{ 'aumico_templates_form_equity_group' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.equityGroupName">
            <mat-option *ngFor="let option of equityGroupOptions" [value]="option">
                {{ option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br /><br />
    <mat-form-field *ngIf="template.type === TemplateType.BALANCE">
        <mat-label>{{ 'aumico_templates_form_uncovered_shortfall_assets_fli' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.uncoveredShortfallAssetsFli">
            <mat-option *ngFor="let option of fliOptions" [value]="option">
                {{ option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br /><br />
    <mat-form-field *ngIf="template.type === TemplateType.BALANCE">
        <mat-label>{{ 'aumico_templates_form_uncovered_shortfall_liabilities_fli' | i18next }}</mat-label>
        <mat-select [(ngModel)]="template.uncoveredShortfallLiabilitiesFli">
            <mat-option *ngFor="let option of fliOptions" [value]="option">
                {{ option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br /><br />
    <templates-group
        [templateGroup]="template.group"
        [financialLineItems]="templateFinancialLineItems"
        [parentGroup]="template.group"
        [templateType]="template.type"
        [languages]="languages"
        (removeFromEquityEvent)="onRemoveGroupTemplate($event)"
        (addTemplateGroupEvent)="onAddGroupTemplate($event)"
    ></templates-group>
    <aumico-button [disabled]="!isValidTemplateForm()" (click)="save()">{{
        'aumico_templates_save' | i18next
    }}</aumico-button>
    <aumico-button (click)="directToTemplatesList()">{{
        'aumico_templates_form_back_to_templates_list' | i18next
    }}</aumico-button>
    <br /><br />
</div>
